import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import axios from "axios";
import CreaComentarios from "views/Crea/CreaComentarios";
import ContratoVariables from "views/Crea/ContratosVariables";
import { useParams } from "react-router-dom";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";

import OtrosSi from "./OtrosSi";
import Pruebas from "./PruebaHtmlPdf";

const Tables = () => {
  let { id } = useParams();
  const cookie = new Cookies();
  const [list, setList] = useState([]);
  const [list1, setList1] = useState([]);
  const [switchState, setSwitchState] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    Swal.fire({
      title: "Cargando información...",
      text: "Por favor espera",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",
      url: `https://contratosback-dev.azurewebsites.net/api/v1/ObtenerUsuarios/${id}`,
    })
      .then((Response) => {
        Swal.close();
        const data = Response.data;
        setList(data);

        if (data.length > 0) {
          const respuesta = data[0];
          cookie.set("id", respuesta.id, { path: "/" });
          cookie.set("Nombre", respuesta.nombre, { path: "/" });
          cookie.set("correo", respuesta.correo, { path: "/" });
          cookie.set("tipo_Usuario", respuesta.tipoUsuarioId, { path: "/" });

          // ✅ Verificar si ya se recargó una vez
          const yaRecargado = localStorage.getItem("yaRecargadoUsuario");

          if (!yaRecargado) {
            localStorage.setItem("yaRecargadoUsuario", "true");
            window.location.reload(); // Recarga la página una sola vez
          } else {
            // Si ya recargó, proceder con la redirección si aplica
            setTimeout(() => {
              if (respuesta.tipoUsuarioId == 5) {
                window.location.assign(
                  `/admin/solicitudesAsignadas/${respuesta.correo}`
                );
              } else if (respuesta.tipoUsuarioId == 6) {
                window.location.assign(`/admin/solicitudes/${respuesta.id}`);
              }
            }, 300);
          }
        } else {
          console.warn("No se encontraron usuarios.");
        }
      })
      .catch((error) => {
        Swal.close();
        Swal.fire({
          title: "Error",
          text: "No se pudo cargar la información del usuario",
          icon: "error",
        });
        console.error(error);
      });
  }, [id]);
  const tipoUsuarioId = cookie.get("tipo_Usuario");

  useEffect(() => {
    if (!tipoUsuarioId) {
      Swal.fire({
        icon: "warning",
        title: "Debe iniciar sesión",
        text: "Por favor, inicie sesión para continuar.",
        confirmButtonText: "Aceptar",
      }).then(() => {
        window.location.href = "/auth/login";
      });
    }
  }, [tipoUsuarioId]);
  useEffect(() => {
    const fetchCasosAsignados = async () => {
      try {
        const response = await axios({
          auth: {
            username: "admin.icontec@icontec.org",
            password: "quAngEraMuSTerGerEDE",
          },
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
          method: "get",
          url: `https://contratosback-dev.azurewebsites.net/api/v1/ObtenerCasosPorUsuario/${cookie.get(
            "id"
          )}`,
        });

        setList1(response.data);

        const initialSwitchState = {};
        response.data.forEach((item) => {
          initialSwitchState[item.id] = item.aprobacionTecnica == 1;
        });
        setSwitchState(initialSwitchState);
      } catch (error) {
        console.log(error);
      }
    };

    fetchCasosAsignados();
  }, []);

  const nuevaSolicitud = () => {
    window.location.href = "/admin/CrearSolicitud";
  };

  const filteredItems = list1.filter((item) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      item.id.toString().toLowerCase().includes(searchLower) ||
      item.fecha.toLowerCase().includes(searchLower) ||
      item.nombreProveedor.toLowerCase().includes(searchLower) ||
      item.nit.toLowerCase().includes(searchLower) ||
      item.direccion.toLowerCase().includes(searchLower) ||
      item.ciudad.toLowerCase().includes(searchLower) ||
      item.telefono.toLowerCase().includes(searchLower)
    );
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

  const formatDate = (dateString) => {
    return dateString.split("T")[0];
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Solicitudes</h3>
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Buscar..."
                  className="form-control mt-3"
                />
              </CardHeader>
              <div className="text-center">
                <button
                  variant="contained"
                  className="btn btn-primary btn-lg"
                  color="primary"
                  onClick={nuevaSolicitud}
                >
                  Nueva Solicitud
                </button>
              </div>
              <hr />
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">OtrosSí</th>
                    <th scope="col">N° Contrato</th>
                    <th scope="col">N° Contrato OtrosSí</th>
                    <th scope="col">Fecha</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Nombre Proveedor</th>
                    <th scope="col">N° Documento</th>
                    <th scope="col">Dirección</th>
                    <th scope="col">Ciudad</th>
                    <th scope="col">Teléfono</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((item) => (
                    <tr key={item.id}>
                      <td>
                        <OtrosSi numContrato={item.numeroContrato} />
                      </td>
                      <td>{item.id}</td>
                      <td>{item.numeroContrato}</td>
                      <td>{formatDate(item.fecha)}</td>
                      <td>
                        {item.descripcion}
                        <br />
                        {item.nombre}
                      </td>
                      <td>{item.nombreProveedor}</td>
                      <td>{item.nit}</td>
                      <td>{item.direccion}</td>
                      <td>{item.ciudad}</td>
                      <td>{item.telefono}</td>

                      {item.pasoAprobacion === 9 ? (
                        <td>
                          <Pruebas id={item.id} />
                        </td>
                      ) : (
                        <td></td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination className="pagination justify-content-end mb-0">
                    <PaginationItem disabled={currentPage === 1}>
                      <PaginationLink onClick={() => paginate(currentPage - 1)}>
                        <i className="fas fa-angle-left" />
                        <span className="sr-only">Previous</span>
                      </PaginationLink>
                    </PaginationItem>
                    {[...Array(totalPages)].map((_, i) => (
                      <PaginationItem key={i} active={currentPage === i + 1}>
                        <PaginationLink onClick={() => paginate(i + 1)}>
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    ))}
                    <PaginationItem disabled={currentPage === totalPages}>
                      <PaginationLink onClick={() => paginate(currentPage + 1)}>
                        <i className="fas fa-angle-right" />
                        <span className="sr-only">Next</span>
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Tables;
